import PropTypes from 'prop-types';
import React from 'react';
import styles from './LiveRegion.module.css';

class LiveRegion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message1: '',
      message2: '',
    };

    this.setAlternate = false;
  }

  componentWillReceiveProps(nextProps) {
    const { message: oldMessage } = this.props;
    const { message } = nextProps;

    if (oldMessage !== message) {
      this.setState({
        message1: this.setAlternate ? '' : message,
        message2: this.setAlternate ? message : '',
      });
      this.setAlternate = !this.setAlternate;
    }
  }

  static defaultProps = {
    message: '',
  };

  render() {
    const { message, ...otherProps } = this.props;
    return (
      <div aria-relevant="additions" {...otherProps}>
        <div className={styles.messageBlock} aria-atomic="true">
          {this.state.message1}
        </div>
        <div className={styles.messageBlock} aria-atomic="true">
          {this.state.message2}
        </div>
      </div>
    );
  }
}

LiveRegion.propTypes = {
  message: PropTypes.string,
};

export default LiveRegion;